import { APIProvider } from "@vis.gl/react-google-maps";
import { PropsWithChildren } from "react";
import { useAuthStore } from "service";

const GOOGLE_MAPS_LIBRARIES: ("marker" | "places")[] = ["marker", "places"];

const MapProvider = ({ children }: PropsWithChildren) => {
  const { customer } = useAuthStore();

  return (
    <APIProvider
      apiKey={customer?.googleMapsApiKey || ""}
      libraries={GOOGLE_MAPS_LIBRARIES}
    >
      {children}
    </APIProvider>
  );
};

export default MapProvider;
